import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { fetchClient, userApiClient } from '@/setup/api'

export const getRestaurantReviewSummaryQueryOptions = (restaurantSlug: string, locale: string) => {
    const init = {
        params: { path: { restaurantSlug } },
        headers: { 'accept-language': locale },
    }

    return {
        queryKey: userApiClient.queryOptions(
            'get',
            '/web/restaurants/{restaurantSlug}/review-summary',
            init
        ).queryKey,
        queryFn: async ({ signal }: { signal: AbortSignal }) => {
            const { data, error, response } = await fetchClient.GET(
                '/web/restaurants/{restaurantSlug}/review-summary',
                { ...init, signal }
            )

            if (response.status === 404) return null
            if (error) throw error

            return data ?? null
        },
        enabled: !!restaurantSlug,
    }
}

export function useGetRestaurantReviewSummaryQuery(restaurantSlug: string) {
    const locale = useLocale()

    return useQuery(getRestaurantReviewSummaryQueryOptions(restaurantSlug, locale))
}
